import { render, staticRenderFns } from "./ButtonRemoveBuyer.vue?vue&type=template&id=02488431&"
import script from "./ButtonRemoveBuyer.vue?vue&type=script&lang=ts&"
export * from "./ButtonRemoveBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports